export default "__VITE_ASSET__DsgUHXCo__"